import queryString from "query-string";
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";

import { UserContext } from "../../Context/UserContext";
import { GemRoutes } from "../../Routes";

interface IProtectedRouteProps {
  /** Flag indicating if the route requires the user to have admin permissions for access. */
  requireAdmin?: boolean;
  /** The DOM element to be rendered by the route. */
  element: JSX.Element;
}

/** A routing component which protects a route by requiring that a token exist and that the user be an admin.
 * Visitors who fail these criterion are redirected to the login page or home page, respectively.
 */
const ProtectedRoute: React.FC<IProtectedRouteProps> = ({ requireAdmin = false, element }) => {
  const { token, user } = useContext(UserContext);
  const { leadId } = queryString.parse(window.location.search);
  return !token ? (
    // if no token, send to login
    <Navigate to={{ pathname: GemRoutes.Login, search: leadId ? window.location.search : undefined }} />
  ) : requireAdmin && !user.isAdmin ? (
    // else if path requires admin and user is non-admin, send to home
    <Navigate to="/" />
  ) : (
    // else send to destination
    element
  );
};

export default ProtectedRoute;
